'use client'

// PhotoCapture — lives inside the canvas and services shutter presses.
// Watches the photo mailbox each frame; when a request lands it reads the
// frame that just went up and hands back a cropped PNG. Costs nothing while
// idle (a null check per frame) and never touches React state.

import { useFrame, useThree } from '@react-three/fiber'
import { photoRequest, captureCanvas } from '../../lib/photo/capture'

export function PhotoCapture() {
  const { gl } = useThree()

  useFrame(() => {
    const req = photoRequest.pending
    if (!req) return
    // Clear before awaiting so a slow capture can't be picked up twice.
    photoRequest.pending = null
    captureCanvas(gl, req.ratio)
      .then(req.resolve)
      .catch(() => req.resolve(null))
  })

  return null
}

export default PhotoCapture
